// Must stay the first import: it installs the dev preview fetch stub (dev only).
import { showAdminPreview } from './dev/adminPreview/install';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { applyStatusColorCssVars } from './utils/statusColors';
import { quietConsoleForProduction } from './utils/quietConsole';

// Must run before anything else logs.
quietConsoleForProduction();
applyStatusColorCssVars();

const AdminPreview = process.env.NODE_ENV === 'development'
  ? React.lazy(() => import('./dev/adminPreview/AdminPreview').then(module => ({ default: module.AdminPreview })))
  : null;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {showAdminPreview && AdminPreview ? (
      <React.Suspense fallback={null}>
        <AdminPreview />
      </React.Suspense>
    ) : (
      <App />
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
